<!-- Model title -->
<div class="panel">

  <!-- Header -->
  <div class="panel__controls">
    <a class="panel__logo" routerLink="/" matTooltip="Back to Dashboard"></a>

    <div class="panel__actions hide-sm">
      <button app-button buttonTheme="light" [routerLink]="['/edit']" [queryParams]="{'id': id}">
        <!-- <fa-icon icon="pen"></fa-icon> -->
        <app-button-icon icon="pen" label="Edit in Studio" iconPlacement="left"></app-button-icon>
      </button>

      <app-bookmark-actions
        theme="light" 
        [bookmark]="(bookmark$ | async)"
        [bookmarkType]="type"
        [bookmarkActions]="bookmarkActions">
      </app-bookmark-actions>
    </div>

    <div class="panel-actions show-sm">
      <!-- Close -->
      <button app-button buttonType="flat" buttonShape="circle" buttonTheme="light" (click)="handleCloseClick()">
        <fa-icon icon="times"></fa-icon>
      </button>
    </div>
  </div>

  <div class="panel__header">

    <div class="panel__lead">
      <div class="panel__breadcrumb" *ngIf="type === 'bookmark'" [routerLink]="['/dashboard']">
        Dashboard
      </div>

      <div class="panel__breadcrumb" *ngIf="type === 'module' && category" [routerLink]="['/explore', category]">
        {{ category | humanize }}
      </div>
      
      <div class="panel__title" *ngIf="title">
        {{ title }}
      </div>
      
      <div class="panel__subtitle" *ngIf="subtitle && subtitle !== title">
        {{ subtitle }}
      </div>
    </div>
  </div>
  
  <!-- Body -->
  <div class="panel__body">  
    <div class="panel__content">
      <ng-content></ng-content>
    </div>
  </div>

  <!-- Footer -->
  <div class="panel__footer" *ngIf="showPanelFooter()">
    <!-- Animation -->
    <div class="panel__animation" *ngIf="isAnimated && (showPlayPause || showScrubber)">
      <app-engine-scrubber [showScrubber]="showScrubber" theme="light"></app-engine-scrubber>
    </div>

    <!-- Footer Navigation -->
    <div class="panel__navigation" *ngIf="chapterCount > 1">
      <button
        app-button
        (click)="handlePreviousClick()"
        matTooltip="Previous Chapter"
        class="w-50"
        buttonSize="large"
        buttonTheme="light">
        <fa-icon icon="angle-left" size="lg"></fa-icon>
      </button>
      
      <div class="panel__chapter-count">
        {{ (selectedChapterIndex$ | async) + 1 }} of {{ (chapters$ | async)?.length }}
      </div>

      <button
        app-button
        (click)="handleNextClick()" 
        matTooltip="Next Chapter"
        class="w-50"
        buttonSize="large"
        buttonTheme="light">
        <fa-icon icon="angle-right" size="lg"></fa-icon>
      </button>
    </div>
  </div>
</div>